import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlidesOriginalPreview = _resolveComponent("SlidesOriginalPreview")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_SlidePreview = _resolveComponent("SlidePreview")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_SlideDetails = _resolveComponent("SlideDetails")!
  const _component_SlideDesginPreview = _resolveComponent("SlideDesginPreview")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_motion_slide_top = _resolveDirective("motion-slide-top")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        fluid: "",
        class: "elevation-5 d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pa-0 d-flex"
              }, {
                default: _withCtx(() => [
                  (_ctx.pdfSource !== undefined || _ctx.pdfSource !== '' )
                    ? (_openBlock(), _createBlock(_component_SlidesOriginalPreview, {
                        key: 0,
                        pdfSource: _ctx.pdfSource,
                        frames: _ctx.frames,
                        onNewSelectedFrame: _ctx.newSelecetedFrameHandling
                      }, null, 8, ["pdfSource", "frames", "onNewSelectedFrame"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, {
                thickness: 2,
                class: "pl-5",
                vertical: ""
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                offset: "1",
                class: "ml-10",
                style: {"position":"relative"}
              }, {
                default: _withCtx(() => [
                  (_ctx.currentFrame?.isReplaced && _ctx.currentFrame?.template?.pdfSource !== undefined && _ctx.currentFrame?.selectedSlideTemplate?.pageNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                          class: "pa-2",
                          style: {"position":"absolute","top":"0","right":"0","width":"200px","z-index":"10"},
                          elevation: "5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SlidePreview, {
                              clearable: "",
                              pdfSource: _ctx.currentFrame?.template.pdfSource,
                              currentPage: _ctx.currentFrame?.selectedSlideTemplate?.pageNumber,
                              style: { cursor: 'pointer' },
                              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.setPreview(_ctx.currentFrame?.template.pdfSource, _ctx.currentFrame?.selectedSlideTemplate?.pageNumber);})
                            }, null, 8, ["pdfSource", "currentPage"])
                          ]),
                          _: 1
                        })), [
                          [_directive_motion_slide_top]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_SlidePreview, {
                    pdfSource: _ctx.pdfSourcePreview,
                    currentPage: _ctx.pagePreview
                  }, null, 8, ["pdfSource", "currentPage"]),
                  (!_ctx.currentFrame?.isReplaced  && _ctx.currentFrame?.template?.pdfSource !== undefined)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        class: "ma-2 pa-2 elevation-5 text-none",
                        "append-icon": "mdi-sticker-plus-outline",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setRepacedFrame()))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Ersetzen")
                        ])),
                        _: 1,
                        __: [5]
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentFrame?.isReplaced  && _ctx.currentFrame?.template?.pdfSource !== undefined)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 2,
                        class: "ma-2 pa-2 elevation-5 text-none",
                        "append-icon": "mdi-sticker-minus-outline",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeReplaced()))
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Entfernen")
                        ])),
                        _: 1,
                        __: [6]
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    class: "ma-2 pa-2 elevation-5 text-none",
                    "append-icon": "mdi-chevron-down ",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDetails = !_ctx.showDetails))
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Deteils zeigen")
                    ])),
                    _: 1,
                    __: [7]
                  }),
                  _createVNode(_component_v_divider, {
                    thickness: 2,
                    class: "pl-5",
                    vertical: ""
                  }),
                  (_ctx.currentFrame && _ctx.showDetails)
                    ? (_openBlock(), _createBlock(_component_SlideDetails, {
                        key: 3,
                        frame: _ctx.currentFrame
                      }, null, 8, ["frame"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, {
                thickness: 2,
                class: "pl-12",
                vertical: ""
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_SlideDesginPreview, {
                    isInProcess: _ctx.isInProcess,
                    currentFrame: _ctx.currentFrame,
                    isInProcessOfNewGenerating: _ctx.isNewGenerating,
                    onGenerateLayoutsSuggestions: _ctx.generateLayoutSuggestionsHandling,
                    onSelectedSuggestedLayout: _ctx.selectedSuggestedLayoutHeandling,
                    onGenerateAgainSuggestions: _ctx.generateAgainLayoutSuggestionsHandling
                  }, null, 8, ["isInProcess", "currentFrame", "isInProcessOfNewGenerating", "onGenerateLayoutsSuggestions", "onSelectedSuggestedLayout", "onGenerateAgainSuggestions"]),
                  _createVNode(_component_v_btn, {
                    class: "ma-2 pa-2 elevation-5 text-none",
                    "append-icon": "mdi-download-box-outline",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generateLatex()))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Präsentation herunterladen")
                    ])),
                    _: 1,
                    __: [8]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}